/**
 * Adapted from the markdown-toc utility, to parallel its functionality.
 *
 * @param string
 * @returns
 */
export function slugify(string: string): string {
  let str = string;

  str = str.toLowerCase();
  str = str.split(' ').join('-');
  str = str.split(/\t/).join('--');
  str = str.split(/<\/?[^>]+>/).join('');
  // eslint-disable-next-line no-useless-escape
  str = str.split(/[|$&`~=\\\/@+*!?({[\]})<>=.,;:'"^]/).join('');
  str = str
    .split(/[。？！，、；：“”【】（）〔〕［］﹃﹄“ ”‘’﹁﹂—…－～《》〈〉「」]/)
    .join('');

  return str;
}
